import en from "./en.json";
import tr from "./tr.json";

const messages: any = {
  EN: en,
  TR: tr,
};

export default messages;
